/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': 'Elements',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': 'Updated',
  'company-hub.hub-element-placeholder.extension.new-lozenge': 'New',
  'company-hub.hub-element-placeholder.extension.sub-heading': 'Nothing here yet. Think of the possibilities...',
  'company-hub.hub-element-placeholder.extension.view-all-options': 'View all options',
  'company-hub.hub-element-placeholder.manifest.extension-title': 'Hub element placeholder',
};
